import { useNavigate, useParams } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { Source as SourceGraphQL, SourceType, UpdateSourceInput } from '@ui/__generated__/graphql'
import { ApolloErrorMessage } from '@ui/components/core/ApolloErrorMessage'
import { showToast } from '@ui/components/elements/ToastManager/ToastManager'
import { Spinner } from '@ui/components/loaders'
import { GetSourceQuery, UpdateSourceQuery } from '@ui/loaders/sources'
import { SourceForm } from '@ui/pages/sources/components/SourceForm'
import { useNavigationStateStore } from '@ui/stores'

export const Source = () => {
  const { sourceId } = useParams()
  const { instanceId } = useNavigationStateStore(useShallow((state) => state.params))

  const { data, loading: loadingGetSource, error: getSourceError } = GetSourceQuery(sourceId)

  const [updateSource, { loading: loadingUpdateSource, error: updateSourceError }] = UpdateSourceQuery()

  const navigate = useNavigate()

  const canEditSource = data?.source.type !== SourceType.CatchAll

  const returnToSources = () => navigate(`/instances/${instanceId}/sources`)

  const onSave = async ({ name }: Pick<UpdateSourceInput, 'name'>) => {
    if (loadingUpdateSource || !sourceId || !canEditSource) return

    const input: UpdateSourceInput = {
      id: parseInt(sourceId),
      name,
    }

    await updateSource({
      variables: { input },
    })

    showToast.success('Source has been saved')

    returnToSources()
  }

  if (loadingGetSource) {
    return <Spinner />
  }

  if (getSourceError) {
    return <ApolloErrorMessage error={getSourceError} />
  }

  const source: SourceGraphQL = data.source

  return (
    <div className="p-4">
      <h1 className="mb-4 text-xl font-medium">Configuration</h1>
      <SourceForm source={source} onSave={onSave} canEdit={canEditSource} onCancel={returnToSources} />
      {updateSourceError && <p className="text-xs italic text-red-500">{updateSourceError.message}</p>}
    </div>
  )
}
